


import React, { useState } from 'react';
import html2pdf from 'html2pdf.js';

const PersonalDetailsForm = () => {
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    surname: '',
    middleName: '',
    preferredName: '',
    primaryStreet: '',
    primaryCity: '',
    primaryState: '',
    primaryCountry: '',
    primaryZip: '',
    supplementaryStreet: '',
    supplementaryCity: '',
    supplementaryState: '',
    supplementaryCountry: '',
    supplementaryZip: '',
    gender: '',
    birthDate: '',
    maritalStatus: '',
    qualification: '',
    positionApplied: '',
    nationality: '',
    stateOfOrigin: '',
    localGovt: '',
    spouseName: '',
    spouseAddress: '',
    spouseTel: '',
    childrenCount: '',
    facebookId: '',
    twitterId: '',
    instagramId: '',
    whatsappId: '',
    skypeId: '',
    bankName: '',
    bvn: '',
    bankBranch: '',
    bankAccountName: '',
    bankAccountNo: '',
    genotype: '',
    weight: '',
    bloodPressure: '',
    bloodGroup: '',
    pastorImamName: '',
    placeOfWorship: '',
    religiousTel: '',
    religiousAddress: '',
    guarantor1Name: '',
    guarantor1HomeAddress: '',
    guarantor1Occupation: '',
    guarantor1BusinessAddress: '',
    guarantor1Relationship: '',
    guarantor1Tel: '',
    guarantor1BankAccountNo: '',
    guarantor1CreditReceived: '',
    guarantor2Name: '',
    guarantor2HomeAddress: '',
    guarantor2Occupation: '',
    guarantor2BusinessAddress: '',
    guarantor2Relationship: '',
    guarantor2Tel: '',
    guarantor2BankAccountNo: '',
    guarantor2CreditReceived: '',
    emergencyFamilyContactName: '',
    emergencyFamilyContactRelationship: '',
    emergencyFamilyContactWorkTel: '',
    emergencyFamilyContactWorkAddress: '',
    emergencyFriendContactName: '',
    emergencyFriendContactRelationship: '',
    emergencyFriendContactWorkTel: '',
    emergencyFriendContactWorkAddress: '',
    employeeSignature: '',
    signatureDate: '',
    ein: ''
  });
  const [sharedContacts, setSharedContacts] = useState({
    emails: [],
    phoneNumbers: []
  });
  const [shareEmail, setShareEmail] = useState('');
  const [sharePhone, setSharePhone] = useState('');
  const [notification, setNotification] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const downloadForm = () => {
    const element = document.getElementById('form-content');
    const opt = {
      margin: 1,
      filename: 'personal_details_form.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    html2pdf().from(element).set(opt).save();
    setNotification('Form downloaded as PDF');
  };

  const printForm = () => {
    window.print();
    setNotification('Form sent to printer');
  };

  const shareViaWhatsApp = () => {
    if (!sharePhone) {
      setNotification('Please enter a phone number to share via WhatsApp');
      return;
    }
    const formContent = JSON.stringify(formData, null, 2);
    const message = encodeURIComponent(`Personal Details Form:\n${formContent}`);
    const url = `https://wa.me/${sharePhone}?text=${message}`;
    window.open(url, '_blank');
    setSharedContacts(prev => ({
      ...prev,
      phoneNumbers: [...new Set([...prev.phoneNumbers, sharePhone])]
    }));
    setSharePhone('');
    setNotification('Form shared via WhatsApp');
  };

const shareViaEmail = async () => {
  if (!shareEmail) {
    setNotification('Please enter an email address to share');
    return;
  }

  const element = document.getElementById('form-content');
  if (!element) {
    setNotification('Error: Form content is not available to send.');
    return;
  }

  setIsSendingEmail(true);

  const opt = {
    margin: 1,
    filename: 'personal_details_form.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  };

  try {
    const pdfBase64 = await html2pdf()
      .set(opt)
      .from(element)
      .output('datauristring');

    const res = await fetch(`${process.env.REACT_APP_API_URL}offer-letter/send-offer-letter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: shareEmail,
        pdfBase64,
        message: 'Please find the attached Personal Details Form.',
      }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || 'Failed to send email');

    setSharedContacts(prev => ({
      ...prev,
      emails: [...new Set([...prev.emails, shareEmail])]
    }));
    setShareEmail('');
    setNotification(`Form sent successfully to ${shareEmail}`);
  } catch (err) {
    console.error(err);
    setNotification('Failed to send form: ' + err.message);
  } finally {
    setIsSendingEmail(false);
  }
};

  const clearNotification = () => {
    setTimeout(() => setNotification(''), 3000);
  };

  return (
    <div className="container mx-auto p-4 max-w-4xl">
      <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">
        Employee Personal Information Form
      </h1>
      <p className="text-center text-gray-600 mb-4">
        Essential.Ng<br />
        No 7, Kaffi Street, Alausa,<br />
        Beside Ikeja City Mall, Lagos.<br />
        Tel: 08154556666
      </p>

      {notification && (
        <div className="mb-4 p-2 bg-green-100 text-green-700 rounded" onClick={clearNotification}>
          {notification}
        </div>
      )}

      <div id="form-content" className="bg-white p-6 rounded-lg shadow-md">
        <form className="space-y-6">
          <h2 className="text-xl font-semibold mb-2">Employee Full Name</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Surname</label>
              <input
                type="text"
                name="surname"
                value={formData.surname}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">First Name</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Middle Name</label>
              <input
                type="text"
                name="middleName"
                value={formData.middleName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Preferred Name</label>
              <input
                type="text"
                name="preferredName"
                value={formData.preferredName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Primary Address (Mailing)</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Street</label>
              <input
                type="text"
                name="primaryStreet"
                value={formData.primaryStreet}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">City</label>
              <input
                type="text"
                name="primaryCity"
                value={formData.primaryCity}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">State</label>
              <input
                type="text"
                name="primaryState"
                value={formData.primaryState}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Country</label>
              <input
                type="text"
                name="primaryCountry"
                value={formData.primaryCountry}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Zip Code</label>
              <input
                type="text"
                name="primaryZip"
                value={formData.primaryZip}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Supplementary Address</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Street</label>
              <input
                type="text"
                name="supplementaryStreet"
                value={formData.supplementaryStreet}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">City</label>
              <input
                type="text"
                name="supplementaryCity"
                value={formData.supplementaryCity}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">State</label>
              <input
                type="text"
                name="supplementaryState"
                value={formData.supplementaryState}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Country</label>
              <input
                type="text"
                name="supplementaryCountry"
                value={formData.supplementaryCountry}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Zip Code</label>
              <input
                type="text"
                name="supplementaryZip"
                value={formData.supplementaryZip}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Gender</label>
              <input
                type="text"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Birth Date (DD-MM-YYYY)</label>
              <input
                type="date"
                name="birthDate"
                value={formData.birthDate}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Marital Status</label>
              <input
                type="text"
                name="maritalStatus"
                value={formData.maritalStatus}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Home/Cell Telephone Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700">Qualification</label>
              <textarea
                name="qualification"
                value={formData.qualification}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="3"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Employment</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Position Applied For/Dept</label>
              <input
                type="text"
                name="positionApplied"
                value={formData.positionApplied}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Nationality</label>
              <input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">State of Origin</label>
              <input
                type="text"
                name="stateOfOrigin"
                value={formData.stateOfOrigin}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Local Govt. Area</label>
              <input
                type="text"
                name="localGovt"
                value={formData.localGovt}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Family</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Spouse Name</label>
              <input
                type="text"
                name="spouseName"
                value={formData.spouseName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Spouse Address</label>
              <input
                type="text"
                name="spouseAddress"
                value={formData.spouseAddress}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Spouse Tel</label>
              <input
                type="tel"
                name="spouseTel"
                value={formData.spouseTel}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Number of Children</label>
              <input
                type="number"
                name="childrenCount"
                value={formData.childrenCount}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Social Media Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Facebook ID</label>
              <input
                type="text"
                name="facebookId"
                value={formData.facebookId}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Twitter ID</label>
              <input
                type="text"
                name="twitterId"
                value={formData.twitterId}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Instagram ID</label>
              <input
                type="text"
                name="instagramId"
                value={formData.instagramId}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">WhatsApp ID</label>
              <input
                type="text"
                name="whatsappId"
                value={formData.whatsappId}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Tel</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Skype</label>
              <input
                type="text"
                name="skypeId"
                value={formData.skypeId}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Bank Account Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Bank Name</label>
              <input
                type="text"
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">BVN</label>
              <input
                type="text"
                name="bvn"
                value={formData.bvn}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Bank Branch</label>
              <input
                type="text"
                name="bankBranch"
                value={formData.bankBranch}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Account Name</label>
              <input
                type="text"
                name="bankAccountName"
                value={formData.bankAccountName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Account No</label>
              <input
                type="text"
                name="bankAccountNo"
                value={formData.bankAccountNo}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Medical Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Genotype</label>
              <input
                type="text"
                name="genotype"
                value={formData.genotype}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Weight</label>
              <input
                type="text"
                name="weight"
                value={formData.weight}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Blood Pressure</label>
              <input
                type="text"
                name="bloodPressure"
                value={formData.bloodPressure}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Blood Group</label>
              <input
                type="text"
                name="bloodGroup"
                value={formData.bloodGroup}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Religious Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Pastor/Imam Name</label>
              <input
                type="text"
                name="pastorImamName"
                value={formData.pastorImamName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Place of Worship (Church/Mosque)</label>
              <input
                type="text"
                name="placeOfWorship"
                value={formData.placeOfWorship}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Tel</label>
              <input
                type="tel"
                name="religiousTel"
                value={formData.religiousTel}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700">Address</label>
              <textarea
                name="religiousAddress"
                value={formData.religiousAddress}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="3"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">1st Guarantor Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <input
                type="text"
                name="guarantor1Name"
                value={formData.guarantor1Name}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Home Address</label>
              <input
                type="text"
                name="guarantor1HomeAddress"
                value={formData.guarantor1HomeAddress}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Occupation</label>
              <input
                type="text"
                name="guarantor1Occupation"
                value={formData.guarantor1Occupation}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Business Address</label>
              <input
                type="text"
                name="guarantor1BusinessAddress"
                value={formData.guarantor1BusinessAddress}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Relationship</label>
              <input
                type="text"
                name="guarantor1Relationship"
                value={formData.guarantor1Relationship}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Tel</label>
              <input
                type="tel"
                name="guarantor1Tel"
                value={formData.guarantor1Tel}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Bank Account No</label>
              <input
                type="text"
                name="guarantor1BankAccountNo"
                value={formData.guarantor1BankAccountNo}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Credit Received</label>
              <input
                type="text"
                name="guarantor1CreditReceived"
                value={formData.guarantor1CreditReceived}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">2nd Guarantor Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <input
                type="text"
                name="guarantor2Name"
                value={formData.guarantor2Name}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Home Address</label>
              <input
                type="text"
                name="guarantor2HomeAddress"
                value={formData.guarantor2HomeAddress}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Occupation</label>
              <input
                type="text"
                name="guarantor2Occupation"
                value={formData.guarantor2Occupation}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Business Address</label>
              <input
                type="text"
                name="guarantor2BusinessAddress"
                value={formData.guarantor2BusinessAddress}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Relationship</label>
              <input
                type="text"
                name="guarantor2Relationship"
                value={formData.guarantor2Relationship}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Tel</label>
              <input
                type="tel"
                name="guarantor2Tel"
                value={formData.guarantor2Tel}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Bank Account No</label>
              <input
                type="text"
                name="guarantor2BankAccountNo"
                value={formData.guarantor2BankAccountNo}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Credit Received</label>
              <input
                type="text"
                name="guarantor2CreditReceived"
                value={formData.guarantor2CreditReceived}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Emergency Contact Information (Family)</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <input
                type="text"
                name="emergencyFamilyContactName"
                value={formData.emergencyFamilyContactName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Relationship</label>
              <input
                type="text"
                name="emergencyFamilyContactRelationship"
                value={formData.emergencyFamilyContactRelationship}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Work Tel</label>
              <input
                type="tel"
                name="emergencyFamilyContactWorkTel"
                value={formData.emergencyFamilyContactWorkTel}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700">Work Address</label>
              <textarea
                name="emergencyFamilyContactWorkAddress"
                value={formData.emergencyFamilyContactWorkAddress}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="3"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Emergency Contact Information (Friend)</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <input
                type="text"
                name="emergencyFriendContactName"
                value={formData.emergencyFriendContactName}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Relationship</label>
              <input
                type="text"
                name="emergencyFriendContactRelationship"
                value={formData.emergencyFriendContactRelationship}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Work Tel</label>
              <input
                type="tel"
                name="emergencyFriendContactWorkTel"
                value={formData.emergencyFriendContactWorkTel}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700">Work Address</label>
              <textarea
                name="emergencyFriendContactWorkAddress"
                value={formData.emergencyFriendContactWorkAddress}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="3"
              />
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-2 mt-6">Employee Declaration</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Employee Signature</label>
              <input
                type="text"
                name="employeeSignature"
                value={formData.employeeSignature}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Date</label>
              <input
                type="date"
                name="signatureDate"
                value={formData.signatureDate}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">EIN</label>
              <input
                type="text"
                name="ein"
                value={formData.ein}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </form>
      </div>

      <div className="mt-6 flex flex-wrap gap-4">
        <button
          onClick={downloadForm}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-200"
        >
          Download PDF
        </button>
        <button
          onClick={printForm}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-200"
        >
          Print Form
        </button>
        <div className="flex items-center gap-2">
          <input
            type="tel"
            value={sharePhone}
            onChange={(e) => setSharePhone(e.target.value)}
            placeholder="Enter WhatsApp number"
            className="border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={shareViaWhatsApp}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-200"
          >
            Share via WhatsApp
          </button>
        </div>
        <div className="flex items-center gap-2">
          <input
  type="email"
  value={shareEmail}
  onChange={(e) => setShareEmail(e.target.value)}
  placeholder="Enter email address"
  disabled={isSendingEmail}
  className="border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
/>
         
          <button
  onClick={shareViaEmail}
  disabled={isSendingEmail}
  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-200 disabled:opacity-50"
>
  {isSendingEmail ? 'Sending...' : 'Share via Email'}
</button>
         
        </div>
      </div>

      <div className="mt-6">
        <h2 className="text-xl font-semibold mb-2">Shared Contacts</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h3 className="text-lg font-medium">Emails</h3>
            <ul className="list-disc pl-5">
              {sharedContacts.emails.length > 0 ? (
                sharedContacts.emails.map((email, index) => (
                  <li key={index} className="text-gray-600">{email}</li>
                ))
              ) : (
                <li className="text-gray-500">No emails shared yet</li>
              )}
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-medium">Phone Numbers</h3>
            <ul className="list-disc pl-5">
              {sharedContacts.phoneNumbers.length > 0 ? (
                sharedContacts.phoneNumbers.map((phone, index) => (
                  <li key={index} className="text-gray-600">{phone}</li>
                ))
              ) : (
                <li className="text-gray-500">No phone numbers shared yet</li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetailsForm;